import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import * as AT from "./actionTypes";
import { RootState, SubscriptionWithGetIT } from "../../../../models";
import { get as Ajax_get } from "../../app/Ajax";
import { API_URL_GET_SUBSCRIPTIONS } from "../api";

export const getSubscriptions =
    (): ThunkAction<Promise<SubscriptionWithGetIT[]>, RootState, unknown, AnyAction> => (dispatch) => {
        const promise = Ajax_get<SubscriptionWithGetIT[]>(
            {
                url: API_URL_GET_SUBSCRIPTIONS,
            },
            dispatch,
        );

        dispatch({
            type: AT.SUBSCRIPTION_LISTING_GET_SUBSCRIPTIONS,
            payload: promise,
        });

        return promise;
    };
